import { getRequestHeaders } from './headers';
import { handleError, apiFetch, API_BASE } from './api';

export interface SOPResource {
    name: string;
    url: string;
}

export interface SOPChange {
    whatIsChanging: string;
    regionsImpacted: string[];
    resources: SOPResource[];
    changeType: string;
    reasonForChange: string;
}

export interface SOPBatchSnapshot {
    changes: SOPChange[];
    updatedBy: string;
    updatedAt: string;
}

export interface SOPBatchEntry {
    pk: string;
    gsi1pk?: string;
    gsi1sk?: string;
    sopBatchId: string;
    publishedAt: string;
    expiresAt: string;
    changes: SOPChange[];
    createdBy: string;
    createdAt: string;
    updatedBy: string;
    updatedAt: string;
    snapshots?: SOPBatchSnapshot[];
    isDeleted?: boolean;
}

export interface PaginatedSOPBatches {
    items: SOPBatchEntry[];
    nextToken?: string;
}

export interface CreateSOPBatchInput {
    changes: SOPChange[];
}

export interface UpdateSOPBatchInput {
    changes?: SOPChange[];
}

export async function fetchSOPBatches(limit = 20): Promise<PaginatedSOPBatches> {
    const res = await apiFetch(`${API_BASE}/sops?limit=${limit}`, {
        headers: getRequestHeaders(),
    });
    if (!res.ok) await handleError(res);
    return res.json();
}

export async function createSOPBatch(input: CreateSOPBatchInput): Promise<SOPBatchEntry> {
    const res = await apiFetch(`${API_BASE}/sops`, {
        method: 'POST',
        headers: getRequestHeaders('application/json'),
        body: JSON.stringify(input),
    });
    if (!res.ok) await handleError(res);
    return res.json();
}

export async function updateSOPBatch(id: string, input: UpdateSOPBatchInput): Promise<SOPBatchEntry> {
    const res = await apiFetch(`${API_BASE}/sops/${encodeURIComponent(id)}`, {
        method: 'PUT',
        headers: getRequestHeaders('application/json'),
        body: JSON.stringify(input),
    });
    if (!res.ok) await handleError(res);
    return res.json();
}

export async function deleteSOPBatch(id: string): Promise<void> {
    const res = await apiFetch(`${API_BASE}/sops/${encodeURIComponent(id)}`, {
        method: 'DELETE',
        headers: getRequestHeaders(),
    });
    if (!res.ok) await handleError(res);
}
